import styled from "styled-components";

export const StyledContactSection = styled.section`
  max-width: 800px;
  color: var(--rose-70);

  h2 {
    font-size: var(--fz-title);
  }

  p {
    margin-bottom: 30px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    font-size: var(--fz-lg);
    margin-top: 24px;
  }

  .contact-links {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;

    a {
      ${({ theme }) => theme.mixins.smallButton};
      font-size: var(--fz-sm);
    }
  }
`;
